"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.text = {
    cursor: 'default',
    fontFamily: '"Source Sans Pro", sans-serif',
};
exports.bold = {
    fontWeight: 700,
};
exports.semibold = {
    fontWeight: 600,
};
exports.regular = {
    fontWeight: 400,
};
exports.light = {
    fontWeight: 300,
};
exports.large = {
    fontSize: 19,
};
exports.medium = {
    fontSize: 17,
};
exports.small = {
    fontSize: 15,
};
